import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-pcomp-bsaccordion',
	templateUrl:'./BSAccordionPluginCompPage.html',
	styles: [],
	styleUrls:['./BSAccordionPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class BSAccordionPluginCompPage
{
	mdContent_767 = `\`\`\`java
import com.jwebmp.plugins.bootstrap.accordion.BSAccordion;
\`\`\``;
	mdContent_768 = `\`\`\`java
BSAccordion()
\`\`\``;
	mdContent_769 = `\`\`\`java
BSAccordion&lt;?&gt; accordion = new BSAccordion&lt;&gt;();
accordion.setCloseOthers(true);
accordion.addPanel("panel1", "Header", new Paragraph&lt;&gt;().setText("Content"), true);
\`\`\``;
}
